import { FaWhatsapp } from "react-icons/fa";
import Interior from "../../../Assets/Images/Interior.jpg";
import Fashion from "../../../Assets/Images/Fashion.jpg";
import Photography from "../../../Assets/Images/Photography.jpg";
import Diploma from "../../../Assets/Images/Diploma.jpg";
import Global from "../../../Assets/Images/Global.jpg";
import Animation from "../../../Assets/Images/Animation.jpg";
import Beauty from "../../../Assets/Images/Beauty.jpg";
import Graphic from "../../../Assets/Images/Graphic.jpg";
import axios from "axios";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Card() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const allCourses = () => {
    let config = {
      method: "get",
      maxBodyLength: Infinity,
      url: `${process.env.REACT_APP_API_URL}/courses/get-all`,
      headers: {},
    };

    axios
      .request(config)
      .then((response) => {
        const allData = response?.data?.data || [];
        const apiCourses = allData.slice(0, 6).map((course) => ({
          ...course,
          isStatic: false,
        }));
        setCourses(apiCourses);
      })
      .catch((error) => {
        console.log(error);
        setCourses([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    allCourses();
  }, []);

  const getImageByTitle = (title = "") => {
    const t = title.trim().toLowerCase();

    if (t === "fashion designing" || t === "fashion design") return Fashion;
    if (t === "interior designing" || t === "interior design") return Interior;
    if (t === "graphic designing" || t === "graphic design") return Graphic;
    if (t === "animation design" || t === "animation designing")
      return Animation;
    if (t === "beauty and makeup") return Beauty;
    if (t === "global degree") return Global;
    if (t === "diploma course" || t === "diploma courses") return Diploma;
    if (t === "photography") return Photography;
    if (t === "ui/ux design" || t === "ui/ux designing") return Photography;
    return "";
  };

  const slugify = (text) =>
    text
      .toString()
      .toLowerCase()
      .trim()
      .replace(/\s+/g, "-")
      .replace(/[^\w\-]+/g, "")
      .replace(/\-\-+/g, "-");

  const SkeletonCard = () => (
    <div className="min-w-[280px] sm:min-w-[300px] bg-white rounded-2xl shadow-md overflow-hidden animate-pulse">
      <div className="w-full h-52 bg-gray-200"></div>
      <div className="p-4 flex gap-4 items-center">
        <div className="w-6 h-6 bg-gray-200 rounded-full"></div>
        <div className="h-5 w-3/4 bg-gray-200 rounded"></div>
      </div>
    </div>
  );

  const renderCourseCard = (course, key) => (
    <Link
      key={key}
      to={`/courses/${slugify(course.category)}`}
      state={{ courseId: course._id }}
      className="block min-w-[280px] sm:min-w-[300px] bg-white rounded-lg shadow-md hover:shadow-xl overflow-hidden transition-shadow duration-300"
    >
      <div className="relative">
        <img
          src={getImageByTitle(course.category)}
          alt={course.category}
          className="w-full h-52 object-cover"
        />

        <div
          className="absolute w-16 h-16 bottom-3 right-10 bg-white p-2 rounded-full shadow-md cursor-pointer hover:scale-110 transition-transform duration-200"
          onClick={(e) => e.stopPropagation()}
        >
          <a
            href="https://wa.me/7205648333?text=Hi%20there!%20I%20want%20to%20know%20about%20your%20course%20and%20eager%20to%20learn.."
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaWhatsapp className="text-green-500 text-xl w-12 h-12" />
          </a>
        </div>
      </div>

      <div className="p-4 flex gap-4">
        <span className="text-gray-500 text-xl font-bold">👉</span>
        <p className="text-lg font-semibold text-gray-800 capitalize">
          {course.category}
        </p>
      </div>
    </Link>
  );

  return (
    <div className="xl:mx-4 p-6 overflow-hidden">
      {loading ? (
        <div className="flex gap-6">
          {Array.from({ length: 4 }).map((_, i) => (
            <SkeletonCard key={i} />
          ))}
        </div>
      ) : (
        <div className="marquee-container">
          <div className="marquee-track">
            {/* Render twice for a seamless infinite loop */}
            {courses.map((course) => renderCourseCard(course, course._id))}
            {courses.map((course) =>
              renderCourseCard(course, `${course._id}-dup`),
            )}
          </div>
        </div>
      )}

      <style jsx>{`
        .marquee-container {
          width: 100%;
          overflow: hidden;
        }

        .marquee-track {
          display: flex;
          gap: 1.5rem;
          width: max-content;
          animation: scroll-horizontal 30s linear infinite;
        }

        .marquee-container:hover .marquee-track {
          animation-play-state: paused;
        }

        @keyframes scroll-horizontal {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
      `}</style>
    </div>
  );
}

// import { FaWhatsapp } from "react-icons/fa";
// import Interior from "../../../Assets/Images/Interior.jpg";
// import Fashion from "../../../Assets/Images/Fashion.jpg";
// import Photography from "../../../Assets/Images/Photography.jpg";
// import Diploma from "../../../Assets/Images/Diploma.jpg";
// import Global from "../../../Assets/Images/Global.jpg";
// import Animation from "../../../Assets/Images/Animation.jpg";
// import Beauty from "../../../Assets/Images/Beauty.jpg";
// import Graphic from "../../../Assets/Images/Graphic.jpg";
// import axios from "axios";
// import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";

// export default function Card() {
//   const [courses, setCourses] = useState([]);
//   const [loading, setLoading] = useState(true);

//   // Static courses to always display
//   const staticCourses = [
//     {
//       _id: "beauty-makeup",
//       category: "Beauty and Makeup",
//       path: "/beauty-and-makeup-course",
//       isStatic: true,
//     },
//     {
//       _id: "diploma",
//       category: "Diploma Courses",
//       path: "/diploma-course",
//       isStatic: true,
//     },
//   ];

//   const allCourses = () => {
//     let config = {
//       method: "get",
//       maxBodyLength: Infinity,
//       url: `${process.env.REACT_APP_API_URL}/courses/get-all`,
//       headers: {},
//     };

//     axios
//       .request(config)
//       .then((response) => {
//         const allData = response?.data?.data || [];
//         // Add isStatic flag to API courses
//         const apiCourses = allData.slice(0, 6).map((course) => ({
//           ...course,
//           isStatic: false,
//         }));
//         // Combine static courses with API courses
//         setCourses([...staticCourses, ...apiCourses]);
//       })
//       .catch((error) => {
//         console.log(error);
//         // If API fails, still show static courses
//         setCourses(staticCourses);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   };

//   useEffect(() => {
//     allCourses();
//   }, []);

//   const getImageByTitle = (title = "") => {
//     const t = title.trim().toLowerCase();

//     if (t === "fashion designing" || t === "fashion design") return Fashion;
//     if (t === "interior designing" || t === "interior design") return Interior;
//     if (t === "graphic designing" || t === "graphic design") return Graphic;
//     if (t === "animation design" || t === "animation designing")
//       return Animation;
//     if (t === "beauty and makeup") return Beauty;
//     if (t === "global degree") return Global;
//     if (t === "diploma course" || t === "diploma courses") return Diploma;
//     if (t === "photography") return Photography;
//     if (t === "ui/ux design" || t === "ui/ux designing") return Photography;
//     return "";
//   };

//   const slugify = (text) =>
//     text
//       .toString()
//       .toLowerCase()
//       .trim()
//       .replace(/\s+/g, "-")
//       .replace(/[^\w\-]+/g, "")
//       .replace(/\-\-+/g, "-");

//   const SkeletonCard = () => (
//     <div className="bg-white rounded-2xl shadow-md overflow-hidden animate-pulse">
//       <div className="w-full h-52 bg-gray-200"></div>
//       <div className="p-4 flex gap-4 items-center">
//         <div className="w-6 h-6 bg-gray-200 rounded-full"></div>
//         <div className="h-5 w-3/4 bg-gray-200 rounded"></div>
//       </div>
//     </div>
//   );

//   return (
//     <div className="xl:mx-4 p-6">
//       <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//         {loading
//           ? Array.from({ length: 8 }).map((_, i) => <SkeletonCard key={i} />)
//           : courses
//               .sort((a, b) => {
//                 // Sort static courses to appear last
//                 if (a.isStatic && !b.isStatic) return 1;
//                 if (!a.isStatic && b.isStatic) return -1;
//                 return 0;
//               })
//               .map((course) => {
//                 // Use predefined path for static courses, otherwise generate slug
//                 const linkPath = course.isStatic
//                   ? course.path
//                   : `/courses/${slugify(course.category)}`;

//                 // Only pass courseId state for API courses
//                 const linkState = course.isStatic
//                   ? {}
//                   : { courseId: course._id };

//                 return (
//                   <Link
//                     key={course._id}
//                     to={linkPath}
//                     state={linkState}
//                     className="block bg-white rounded-lg shadow-md hover:shadow-xl overflow-hidden transition-all duration-300"
//                   >
//                     <div className="relative">
//                       <img
//                         src={getImageByTitle(course.category)}
//                         alt={course.category}
//                         className="w-full h-52 object-cover transform hover:scale-105 transition-transform duration-200"
//                       />

//                       <div
//                         className="absolute w-16 h-16 bottom-3 right-10 bg-white p-2 rounded-full shadow-md cursor-pointer hover:scale-110 transition-transform duration-200"
//                         onClick={(e) => e.stopPropagation()}
//                       >
//                         <a
//                           href="https://wa.me/7205648333?text=Hi%20there!%20I%20want%20to%20know%20about%20your%20course%20and%20eager%20to%20learn.."
//                           target="_blank"
//                           rel="noopener noreferrer"
//                         >
//                           <FaWhatsapp className="text-green-500 text-xl w-12 h-12" />
//                         </a>
//                       </div>
//                     </div>

//                     <div className="p-4 flex gap-4">
//                       <span className="text-gray-500 text-xl font-bold">
//                         👉
//                       </span>
//                       <p className="text-lg font-semibold text-gray-800 capitalize">
//                         {course.category}
//                       </p>
//                     </div>
//                   </Link>
//                 );
//               })}
//       </div>
//     </div>
//   );
// }
